export const DATE_LETTERS = 'LL';
export const DOT_DAY_MONTH = 'DD.MM';
export const DOT_DAY_MONTH_YEAR = 'DD.MM.YYYY';
export const DASH_YEAR_MONTH_DAY = 'YYYY-MM-DD';
export const DASH_YEAR_MONTH_DAY_HOUR_MINUTE = 'YYYY-MM-DD[T]HH:mm';
export const DAYS = 'days';
